import React, { useState } from "react";

const Options = (props) =>  {
    const [ checked, setChecked ] = useState( props.checked(props.value) );

    return (
        <div className="options"  onClick={ async() => { 
                                        await setChecked( !checked );
                                        await props.setFunction( props.value ); 
                                    }}>
            <div className={"check " + ( checked ? 'checked':'')} />
            <img src={ props.icon } alt={ props.title } />
            <p>{ props.title }</p>
        </div>
    );
    
}

export default Options;